import type { Theme } from '@mui/material'
import { shiftTypes } from 'constants/shift'
import type { PlannedShiftT } from 'types'

export const getBackgroundColor = (shift: PlannedShiftT, theme: Theme): string => {
  if (shift.type === shiftTypes.absence) {
    return theme.palette.grey[50]
  }

  return shift.hexBackgroundColor && shift.hexBackgroundColor !== ''
    ? shift.hexBackgroundColor
    : theme.palette.primary.main
}
